import type { Theme } from 'baseui';
import { SELECT_PROPS } from '../../../constants/constants';
import { CODE_LANGUAGE_FRIENDLY_NAME_MAP } from '@lexical/code';
export const SELECT_STYLE_OVERRIDES = {
  overrides: {
    ...SELECT_PROPS.overrides,
    ValueContainer: {
      style: ({
        $theme
      }: {
        $theme: Theme;
      }) => ({
        paddingTop: $theme.sizing.scale0,
        paddingBottom: $theme.sizing.scale0
      })
    }
  }
};
export const CODE_LANGUAGE_OPTIONS = Object.entries(CODE_LANGUAGE_FRIENDLY_NAME_MAP).map(([key, value]) => ({
  languageType: key,
  languageName: value
}));